import React from "react";
import styles from "./FloatingCorner.module.css";

export interface FloatingCornerProps {
  children: React.ReactNode;
}

/**
 * Fixed-position bottom-right wrapper for floating widgets (chat launchers,
 * toasts, etc.) that need to escape normal document flow — the one thing
 * Astryx's layout primitives (Card, Stack) intentionally don't express via
 * props. Purely structural positioning; the child renders its own themed
 * content and must supply its own <Theme> scope if mounted outside one.
 */
const FloatingCorner = ({ children }: FloatingCornerProps): React.ReactElement => {
  return <div className={styles.corner}>{children}</div>;
};

export default FloatingCorner;
